import { QUALIFICATION_CHECK_STATUS } from '../../constants';
import { AR_QUALIFICATION_CHECK_TEXT } from '../../lang';
import { type SelectOption } from '../../../../components';

export const qualificationCheckOptions: SelectOption[] = [
  {
    label: AR_QUALIFICATION_CHECK_TEXT.COMPLETED,
    value: QUALIFICATION_CHECK_STATUS.PASSED,
  },
  {
    label: AR_QUALIFICATION_CHECK_TEXT.NOT_YET_COMPLETED,
    value: QUALIFICATION_CHECK_STATUS.CHECKING,
  },
  {
    label: AR_QUALIFICATION_CHECK_TEXT.WAIVED,
    value: QUALIFICATION_CHECK_STATUS.WAIVED,
  },
];
